import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Box,
    Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RegistrationForm from './front/RegistrationForm';

const RegistrationModal = ({ open, onClose }) => {
    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '12px',
                    maxHeight: '90vh',
                    overflow: 'auto'
                }
            }}
        >
            <DialogTitle sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                padding: '20px 24px 10px 24px',
                borderBottom: '1px solid #e0e0e0'
            }}>
                <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#007bff' }}>
                    Realizar Cadastro
                </Typography>
                <IconButton
                    onClick={onClose}
                    sx={{
                        color: '#666',
                        '&:hover': {
                            backgroundColor: '#f5f5f5'
                        }
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            
            <DialogContent sx={{ padding: 0 }}>
                <Box sx={{ padding: '20px 24px' }}>
                    <RegistrationForm />
                </Box>
            </DialogContent>
            
            <DialogActions sx={{ 
                padding: '10px 24px 20px 24px',
                borderTop: '1px solid #e0e0e0'
            }}>
                <Button 
                    onClick={onClose}
                    variant="outlined"
                    sx={{
                        color: '#666',
                        borderColor: '#ddd',
                        '&:hover': {
                            backgroundColor: '#f5f5f5',
                            borderColor: '#bbb'
                        }
                    }}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RegistrationModal;
